import Vue from 'vue'

import Element from 'element-ui'

// == 业务入口 ===
import App from 'src/app'
import router from 'src/router'
import store from 'src/store'

// === css 入口 ===
import 'style'

import 'style/element-ui/theme-chalk'


// == 自定义字符图标 ==
import 'style/iconfont/iconfont'

// === 国际化入口 ===
// import i18n from './i18n'

// === axios拦截器及设置 ===
import axios from 'modules/axios'

Vue.prototype.$axios = axios

Vue.use(Element)

//  面试页跳转需要保留搜索条件
Vue.component('ElMenu').options.methods.routeToItem = function(item) {
    let route = item.route || item.index
    try {
        if (item.$route.path.indexOf('interview') > (-1) && item.index.indexOf('interview') > -1) {
            this.$router.push({path: item.index, query: item.$route.query})
            return
        }
        this.$router.push(route)
    } catch (e) {
        console.error(e)
    }
}
// console.log(Vue.prototype.$msgbox)

Vue.config.productionTip = false
Vue.config.devtools = true
Vue.prototype.$win = {
    close: window.close
}
Vue.prototype.$back = (conf) => {
    router.back()
    let curHref = window.location.href
    clearTimeout(window._back_timer)
    window._back_timer = setTimeout(() => {
        if (window.location.href === curHref) {
            if (typeof conf === 'object') {
                router.push(conf)
            }
        }
    }, 300)
}

window.app = new Vue({
    store,
    router,
    watch: {
        template(newValue) {
            if (newValue === 'default') {
                this.$store.dispatch('FETCH_BASE_DATA')
            }
        }
    },
    computed: {
        template: function () {
            let template,
                meta = this.$route.meta,
                name = this.$route.name
            switch (true) {
                case name === null:
                    template = null
                    break
                case name === 'login' || meta.template === 'full':
                    template = 'full'
                    break
                default:
                    template = 'default'
            }
            return template
        }
    },
    template: '<App :template="template"></App>',
    components: {
        App
    }
}).$mount('#main')



// WEBPACK FOOTER //
// ./src/main.js